import { render, staticRenderFns } from "./IsApproved.vue?vue&type=template&id=c48535bc"
import script from "./IsApproved.vue?vue&type=script&lang=js"
export * from "./IsApproved.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports